import { Component, OnInit, OnDestroy, Input, EventEmitter, Output, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import * as utils from "@foh/shared/services/utils";
import { NewGuestModalComponent } from "@foh/publicpages/newreservationform/new-guest-modal/new-guest-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-edit-reservation',
  templateUrl: './edit-reservation.component.html',
  styleUrls: ['./edit-reservation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class EditReservationComponent implements OnDestroy, OnChanges {

  @Input() record: any = {};
  @Input() guests: any[] = [];
  @Input() showGuestsList: boolean = false;
  @Input() isTicketType: boolean;
  @Input() ticketPrices: any;
  @Input() isReadOnly: boolean = false;
  @Input() modeIsEdit: boolean = false;
  @Input() fbGuestMandatory: boolean;
  @Input() emailGuestMandatory: boolean;
  @Input() mobileNumberAtGlMandatory: boolean;
  @Input() acceptInternationalNumbers: boolean;
  @Input() numberOfPax: number;
  @Input("create-customer-as-guest") createCustomerAsGuest: boolean;
  @Output("on-guest-delete") onGuestDelete = new EventEmitter<any>();
  @Output("on-guestlist-reset") onGuestListReset = new EventEmitter<any>();
  @Output() numberOfPeopleChange = new EventEmitter<number>();
  pax: number = 1;

  constructor(private modalService: NgbModal, private cdr: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.guests) {
      this.calculateTotalPax();
      this.cdr.detectChanges();
    }
    
    if (changes.numberOfPax && this.numberOfPax > 0) {
      const desiredLength = this.numberOfPax;
      const currentLength = this.guests.length;
      const difference = desiredLength - currentLength;

      if (difference > 0) {
        // Add empty guest objects if needed
        this.guests.push(...Array(difference).fill({}));
      } else if (difference < 0) {
        // Remove excess guests and emit delete event if necessary
        const removedGuests = this.guests.splice(desiredLength, Math.abs(difference));
        removedGuests.forEach(guest => {
          if (guest.id) {
            this.onGuestDelete.emit(guest.id);
          }
        });
      }
      this.cdr.detectChanges();
      this.cdr.markForCheck();
    }
    this.onNumberOfPeopleChange();
  }


  ngOnDestroy() {
    this.onGuestDelete.unsubscribe();
    this.onGuestListReset.unsubscribe();
  }

  calculateTotalPax() {
    var paddingHost = 1;
    if (this.modeIsEdit) {
      paddingHost = 0;
    }
    this.pax = this.guests.length + paddingHost;
  }

  openNewGuestModal() {
    const modalRef = this.modalService.open(NewGuestModalComponent, {
      windowClass: "foh-modal"
    });
    modalRef.componentInstance.resTypeId = this.record.typeid;
    modalRef.componentInstance.isTicketType = this.isTicketType;
    modalRef.componentInstance.ticketPrices = this.ticketPrices;
    modalRef.componentInstance.fbGuestMandatory = this.fbGuestMandatory;
    modalRef.componentInstance.emailGuestMandatory = this.emailGuestMandatory;
    modalRef.componentInstance.mobileNumberAtGlMandatory = this.mobileNumberAtGlMandatory;
    modalRef.componentInstance.acceptInternationalNumbers = this.acceptInternationalNumbers;
    modalRef.componentInstance.save.subscribe(params => {
      if (!params || !params._dirty) {
        return; // Ensure the modal only processes valid data
      }

      // Check if guests array is at maximum capacity
      if (this.guests.length >= this.numberOfPax - 1) {
        // Update the last guest rather than adding a new row
        this.guests[this.guests.length - 1] = utils.formatTicketCategoryForGuest(params, this.isTicketType, this.ticketPrices);
      } else {
        // Otherwise, push a new guest to the end of the array
        var guest = utils.formatTicketCategoryForGuest(params, this.isTicketType, this.ticketPrices);
        this.guests.push(guest);
      }

      this.calculateTotalPax();
      modalRef.componentInstance.activeModal.dismiss("Saved");
    });
  }

  updateGuest(guest, index) {
    this.guests[index] = guest;
  }

  onNumberOfPeopleChange() {
    this.numberOfPeopleChange.emit(this.numberOfPax);
    this.cdr.detectChanges();
  }

  resetGuests() {
    this.guests = [];
    this.calculateTotalPax();
    this.onGuestListReset.emit({});
  }
}